<template>
  <div class="p-col-12">
    <div class="card">
      <ancestryline-data-table :data-function="dataFunction" :columns="columns"/>
    </div>
  </div>
</template>

<script>
import AncestrylineDataTable from "@/components/table/AncestrylineDataTable";
import ProtocolBusiness from "@/business/ProtocolBusiness";
export default {
  name: "ClientProtocols",
  components: {AncestrylineDataTable},

  props: {
    client: {type: Object, default: () => {return {}}},
  },

  data() {
    return {
      dataFunction: (sort, direction, page, size, filters = {}) => {
        filters.person_id = this.client.id;
        return ProtocolBusiness.pagination(sort, direction, page, size, filters)
      },
      columns: [
        {field: "code", header: 'dataTable.protocol.columns.protocol', sortable:true, type: 'actions', customFunction: this.protocolName,
          actions: [
            {type: 'protocolLink', title: 'dataTable.protocol.columns.protocol'},
          ]
        },
        {field: "name", header: 'dataTable.protocol.columns.name', sortable:true, type: 'actions',
          actions: [
            {type: 'protocolLink', title: 'dataTable.protocol.columns.protocol'},
          ]
        },
        {field: "created", header: 'dataTable.protocol.columns.created', sortable:true, type: 'date-time'},
        {field: "stageName", header: 'dataTable.protocol.columns.stage', sortable:true},
        {field: "typeServiceName", header: 'dataTable.protocol.columns.type-service', sortable:true},
        {field: "mainClientName", header: 'dataTable.protocol.columns.main-client', sortable:true, type: 'actions',
          actions: [
            {type: "mainClientLink", title: 'dataTable.client.columns.name'},
          ]
        },
      ],
    }
  },

  methods: {

    protocolName: ProtocolBusiness.protocolName,

  }

}
</script>

<style scoped>

</style>